/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material';
import ModalDialog from '../ui/ModalDialog/index';
import { CancelPresentationRounded } from '@mui/icons-material';
import PropTypes from 'prop-types';
import styles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { IMPORT_TABLES_LIST } from '../../utils/constants';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { importWells } from '../../store/actions/wells';

const WellsImportDialog = ({
  onCloseClick,
  isOpen,
  rowData
}) => {
  const classes = styles();
  const wells = useSelector((state) => state.wells);
  const apiRef = useGridApiRef();
  const [well, setWell] = useState('');
  const [tableList, setTableList] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const handleConfirmClose = () => setIsConfirmOpen(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleImport = () => {
    setLoading(true);
    setIsConfirmOpen(false);
    const payload = {
      wellsInfoId: rowData.wellsInfoId,
      fromWellsInfoId: well,
      tables: tableList
    };
    dispatch(importWells(payload, () => {
      setLoading(false);
    }, () => {
      setLoading(false);
      onCloseClick();
    }));
  };

  const getModalTitle = () => (
        <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
                {'Select Well to Import'}
            </Grid>
            <Grid item>
                <IconButton onClick={onCloseClick}>
                    <CancelPresentationRounded fontSize='large' />
                </IconButton>
            </Grid>
        </Grid>
  );

  if (apiRef.current === null) apiRef.current = {};

  return (
        <ModalDialog
            title={getModalTitle()}
            isOpen={isOpen}
            onClose={onCloseClick}
            dialogClass={classes.dialogModal}
        >
            {loading
              ? (
  <Box display="flex" justifyContent="center" alignItems="center" height="300px">
    <CircularProgress size={48} />
  </Box>
                )
              : (
            <Box marginTop='1%' marginLeft='2.5%'>
                <Grid item>
                    <Typography variant="h6" fontWeight={'bold'}>Import From</Typography>
                </Grid>
                <FormControl fullWidth sx={{ bgcolor: 'transparent', width: '80%', marginTop: '1%' }}>
                    <Autocomplete
                        id="well-autocomplete"
                        options={wells.data.filter(item => item.wellsInfoId !== rowData?.wellsInfoId)}
                        getOptionLabel={(option) => option.name}
                        value={wells.data.find(item => item.wellsInfoId === well) || null}
                        onChange={(event, newValue) => setWell(newValue?.wellsInfoId || '')}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Well Name"
                                sx={{
                                  fontWeight: 'bolder',
                                  fontSize: '18px',
                                  background: 'unset'
                                }}
                            />
                        )}
                        sx={{
                          fontSize: '18px',
                          '& .MuiInputBase-input': {
                            fontWeight: 'bold',
                            fontSize: '18px'
                          }
                        }}
                    />
                </FormControl>
                <Grid item sx={{ marginTop: '2%' }}>
                    <Typography variant="h6" fontWeight={'bold'}>Import Tables</Typography>
                </Grid>
                {IMPORT_TABLES_LIST.map((item) => {
                  const isDrillstringsSelected = tableList.includes('WellsDrillStrings');
                  const isDrillFluidsSelected = tableList.includes('WellsDrillFluids');
                  const shouldDisable =
                        item.key === 'HydraulicsRuns' && !(isDrillstringsSelected && isDrillFluidsSelected);
                  return (
                        <Box key={item.key}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        value={item.key}
                                        checked={tableList.includes(item.key)}
                                        onChange={(e) => {
                                          const { checked, value } = e.target;
                                          setTableList((prev) =>
                                            checked ? [...prev, value] : prev.filter((i) => i !== value)
                                          );
                                        }}
                                        disabled={shouldDisable}
                                    />
                                }
                                label={item.label}
                                sx={{
                                  '.MuiFormControlLabel-label': {
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                  },
                                  marginTop: '4px',
                                }}
                            />
                        </Box>
                  );
                })}
              </Box>
                )}
            <Grid container item justifyContent='center' marginBottom='1rem'>
                {!loading && <DialogActions>
                    <Button
                        disabled={!well || tableList.length === 0 || loading}
                        style={{ backgroundColor: '#444', width: '100px', color: '#fff' }}
                        onClick={() => setIsConfirmOpen(true)}
                    >
                        Import
                    </Button>
                </DialogActions>}
            </Grid>

            <Dialog open={isConfirmOpen} onClose={handleConfirmClose} className={classes.dialogModal_confirmation}>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid item>Attention!</Grid>
                            <Grid item>
                                <IconButton
                                    onClick={() => {
                                      handleConfirmClose(false);
                                    }}
                                >
                                    <CancelPresentationRounded fontSize='large' />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Typography>
                </Box>
                <Divider />
                <DialogContent style={{ marginTop: '2px' }}>
                    <DialogContentText align='center' style={{ marginLeft: '-0.7rem' }} color={'black'} fontSize={'18px'} fontWeight='bold' id="alert-dialog-description">
                        Imported tables replace existing data
                    </DialogContentText>
                </DialogContent>
                <Grid container item justifyContent='center' marginBottom='2rem'>
                    <DialogActions>
                        <Button
                            style={{ backgroundColor: '#444', width: '100px' }}
                            onClick={() => {
                              handleImport();
                            }}
                        >
                            Continue
                        </Button>
                    </DialogActions>
                </Grid>
            </Dialog>
        </ModalDialog>
  );
};

WellsImportDialog.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  rowData: PropTypes.object
};

export default WellsImportDialog;
